import React from "react";

import styles from './ImageListCard.module.scss';
import type {ImageListCardData} from "../../types";
import {EMOJIS} from "../../../../../config/constants";
import H4 from "../typography/H4";
import List1 from "../typography/List1";

type ImageListCardProps = {
    card: ImageListCardData;
};


function ImageListCard({card}: ImageListCardProps) {

    return (
        <div className={styles.card}>
            <div className={styles.title} lang="ru">
                <H4 sx={{
                    display: 'block',
                    position: 'relative',
                    top: '4px',
                    '@media (min-width: 1200px)': {
                        fontSize: '32px',
                        lineHeight: 1.28,
                        top: '8px',
                        overflowWrap: 'normal',
                    },
                    '@media screen and (max-width: 575px)': {
                        overflowWrap: 'normal',
                    },
                    '@media (min-width: 992px) and (max-width: 1199px)': {
                        overflowWrap: 'break-word',
                    },
                    '@media (min-width: 768px) and (max-width: 1199px)': {
                        fontSize: '28px',
                        lineHeight: 1.28,
                        overflowWrap: 'normal',
                    },
                }}>{card.title}</H4>
            </div>
            <ul className={styles.list}>
                {card.list.map((item, index) => (
                    <li key={index} className={styles.item}>
                        <span className={styles.itemEmoji}>{EMOJIS.BACKHAND_INDEX_POINTING_RIGHT_LIGHT}</span>
                        <List1>
                            {item}
                        </List1>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default ImageListCard
